import { Container, Button,Form, Alert, Modal} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import React, {useMemo, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import useBackend, {CallAPI, Loading, SpinnerX, Check} from '../../services/useBackend';

export default function MyGroups() {
    const [saving,        setSaving]        = useState(false);
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

    const {loading:registerDataLoading, data:registerData, Refresh} =  useBackend(process.env.PUBLIC_URL+'/api/admin/Register');

    const [editProductGroupData, setEditProductGroupData] = useState(null);
    const [editProductGroupsModalshow, setEditProductGroupsModalshow] = useState(false);
    const initModal = () => { return setEditProductGroupsModalshow(!editProductGroupsModalshow) } 

    var typingTimeout = null;

    const editProductHandler = (event, rowData)  =>  {
        setResultVisible(false);
        setEditProductGroupData(rowData.original)
        setEditProductGroupsModalshow(!editProductGroupsModalshow);        
    }

    const addProductGroupHandler = (event)  =>  {
        event.preventDefault();
        setResultVisible(false);
        setEditProductGroupData({"Guid":"00000000-0000-0000-0000-000000000000", "Name": "", "Description": "", "Active": true})
        setEditProductGroupsModalshow(!editProductGroupsModalshow);  
    }

    function handleChange(event){
        if (editProductGroupData.Guid!=="00000000-0000-0000-0000-000000000000") {
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(handleSave, 475);
        }
    }
        
    async function handleSave(){
        setSaving(true);
        setResultText("");
        setResultVisible(false);
        const GroupForm = document.getElementById('GroupForm');
        const formData = new FormData(GroupForm);
    
        const formDataObj = Object.fromEntries(formData.entries());
        formDataObj.Active = formData.has('Active') ? true : false;
    
        if (editProductGroupData.Guid==="00000000-0000-0000-0000-000000000000") {
             let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/productgroups', 'POST', JSON.stringify(formDataObj));
             if (resultVariant!=="success") {
                 setResultVariant(resultVariant);   
                 setResultText(resultText);
                 setResultVisible(resultVisible);
             } else {
                 initModal();
             }
        } else {
             let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/productgroups/'+editProductGroupData.Guid,"PATCH",JSON.stringify(formDataObj));
             if (resultVariant!=="success") {
                 setResultVariant(resultVariant);   
                 setResultText(resultText);
                 setResultVisible(resultVisible);
            } 
        }
        Refresh();
        setSaving(false);
    }

    async function handleRemove(){
        setSaving(true);

        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/productgroups/'+editProductGroupData.Guid,"DELETE","{}");
        if (errorsException) {
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {
            Refresh();
            initModal();
        }
        setSaving(false);
    }    

    const columns = useMemo(() => [
          { size: 40, accessorKey: 'Name',  header: 'Name' },
          { size: 40, accessorKey: 'Description',  header: 'Description' },          
          { size: 40, accessorKey: 'ProductsCnt',  header: 'Antal varor' },
          { size: 20, accessorKey: 'Active',       header: 'Aktiv', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.Active}/> ),
          },                   
        ]
    );

    const initialState = { density: 'compact' };    
    
    const state = {  };       

    if (!registerDataLoading) {
        return (
            <ContentWrapper>

                {editProductGroupData!=null &&
                    <Modal show={editProductGroupsModalshow} onHide={initModal}>
                    <Modal.Header closeButton>

                    {editProductGroupData.Guid==="00000000-0000-0000-0000-000000000000" ? (  <Modal.Title>Ny varugrupp</Modal.Title> ) :(<Modal.Title>{editProductGroupData.Name}</Modal.Title>)}
                        
                    </Modal.Header>
                    <Modal.Body>
                    <Form onSubmit={handleSave} id="GroupForm">

                        <Form.Group className="mb-3" >
                            <Form.Label>Namn</Form.Label>
                            <Form.Control type="text" name="Name" placeholder="Produktnamn"  defaultValue={editProductGroupData.Name} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Beskrivning</Form.Label>								
                            <Form.Control type="text" name="Description" placeholder="Gruppbeskrivning" defaultValue={editProductGroupData.Description} onChange={handleChange} />
                        </Form.Group>  

                        <Form.Group className="mb-3" >
                            <Form.Check 
                                type="switch"
                                name="Active"
                                id="Active"
                                label="Aktiv"
                                defaultChecked={editProductGroupData.Active}
                                onChange={handleChange}
                            />
                        </Form.Group>  	

                        <Form.Group className="mb-3"  hidden={!saving}>
                            <SpinnerX  />
                        </Form.Group>                                      
                        
                        <Form.Group className="mb-3"  hidden={!resultVisible}>
                            <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                        </Form.Group> 												 													
                    </Form>                   
                    
                    </Modal.Body>
                    <Modal.Footer>
                        {editProductGroupData.Guid==="00000000-0000-0000-0000-000000000000" ? (  
                            <>
                                <Button className="QmeButton" variant="primary" type="button" onClick={handleSave}>Spara</Button>    
                                <Button variant="danger" onClick={initModal}>Avbryt</Button>
                            </>
                        ) : (
                            <>
                                <Button variant="danger" type="button" onClick={handleRemove}>Ta bort varugruppen</Button>    
                                <Button variant="secondary" onClick={initModal}>Stäng</Button>
                            </>
                        )}                                            
                    </Modal.Footer>
                    </Modal>
                }

                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={registerData.productGroups} state={state} initialState={initialState} enablePagination={false}
                        renderTopToolbarCustomActions={() => (<Rubrik>Varugrupper</Rubrik>)}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {editProductHandler(event, row);},sx: {cursor: 'pointer'},})}
                            />                         
                        <Button className="QmeButton" variant="primary" type="submit" onClick={addProductGroupHandler}>Lägg till varugrupp</Button>               
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}